import axios from 'axios'
import { auth } from '@/firebase/config'
import store from '@/store/index'

// Attaches the signed-in user's Firebase ID token as `Authorization: Bearer
// <token>` to every request aimed at the Neutral Fuels API (store.state.apiUrl
// / nf-api.neutralfuels.net), for BOTH transport mechanisms the app uses:
//   - the global axios instance (most composables), and
//   - window.fetch (useNotifications, useOdooApi, zones, supplier-recurring …).
// Only nf-api URLs are touched — calls to Firebase, LaunchDarkly, the separate
// `homebaseClient` axios instance, and any other host pass through untouched.
//
// Once the API enforces auth (AUTH_ENFORCED=true) these requests keep working;
// while it ran dark the header was simply ignored.
let installed = false

function targetsNfApi(url) {
    const apiBase = store.state.apiUrl || ''
    return !!url && ((apiBase && url.startsWith(apiBase)) || url.includes('nf-api.neutralfuels.net'))
}

async function bearer() {
    if (!auth.currentUser) return null
    try {
        return await auth.currentUser.getIdToken()
    } catch (e) {
        return null
    }
}

export function installApiAuthInterceptor() {
    if (installed) return
    installed = true

    // --- axios (global instance) ---------------------------------------------
    axios.interceptors.request.use(async (config) => {
        try {
            const url = `${config.baseURL || ''}${config.url || ''}`
            if (targetsNfApi(url)) {
                const token = await bearer()
                if (token) {
                    config.headers = config.headers || {}
                    config.headers.Authorization = `Bearer ${token}`
                }
            }
        } catch (e) {
            console.warn('[apiAuth] axios token attach failed:', e?.message || e)
        }
        return config
    })

    // --- window.fetch --------------------------------------------------------
    if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
        const originalFetch = window.fetch.bind(window)
        window.fetch = async (input, init) => {
            try {
                const url = typeof input === 'string' ? input : (input && input.url) || ''
                if (targetsNfApi(url)) {
                    const token = await bearer()
                    if (token) {
                        const headers = new Headers(
                            (init && init.headers) ||
                            (typeof input !== 'string' && input && input.headers) ||
                            {}
                        )
                        if (!headers.has('Authorization')) {
                            headers.set('Authorization', `Bearer ${token}`)
                        }
                        init = { ...(init || {}), headers }
                    }
                }
            } catch (e) {
                // Never block a request because token retrieval failed.
            }
            return originalFetch(input, init)
        }
    }
}
